import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { VariantProps } from 'tailwind-variants';

import IconClose from '@/fo/icons/base/icons/close10.svg';

import { styles } from './SuggestionGroup.styles';

type Variants = VariantProps<typeof styles>;

type Item = { icon?: React.ReactNode; text: string; url?: string };

export interface SuggestionGroupProps {
  title: string;
  items: Array<Item>;
  color?: Variants['color'];
  onItemClick?: (item: Item) => void;
  onRemoveAllClick?: () => void;
  onRemoveItemClick?: (item: Item) => void;
}

export function SuggestionGroup({
  title,
  items,
  color,
  onItemClick,
  onRemoveAllClick,
  onRemoveItemClick
}: SuggestionGroupProps) {
  const t = useTranslations();

  const slots = styles({ color });

  const isRemovable = !!onRemoveAllClick || !!onRemoveItemClick;

  return (
    <div className={slots.base()}>
      <div className={slots.title()}>
        {title}
        {onRemoveAllClick && (
          <div
            className={slots.removeAll()}
            onClick={onRemoveAllClick}
          >
            {t('clean')}
          </div>
        )}
      </div>
      {items.map((item, index) => (
        <Link
          key={index}
          href={item.url ?? ''}
          className={slots.item({ isRemovable })}
          onClick={(e) => {
            if (!item.url) {
              e.preventDefault();
            }
            onItemClick?.(item);
          }}
        >
          {item.icon && <span className={slots.icon()}>{item.icon}</span>}
          <div className={slots.text()}>{item.text}</div>
          {onRemoveItemClick && (
            <div
              className={slots.removeItem()}
              onClick={(e) => {
                e.stopPropagation();
                onRemoveItemClick?.(item);
              }}
            >
              <IconClose />
            </div>
          )}
        </Link>
      ))}
    </div>
  );
}
